import { useState } from "react";
import { AxiosRequest } from "_services/api";

export function useReprocessarTaxa() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [loadingReprocessar, setLoadingReprocessar] = useState(false);

  const reprocessar = async (idLote: number, idProcesso: number) => {
    setLoadingReprocessar(true);
    try {
      const { data } = await msAw.post(
        `/financeiro/pagamento-taxa/lote/${idLote}/processos/${idProcesso}/reprocessar`,
      );
      return data;
    } finally {
      setLoadingReprocessar(false);
    }
  };

  const reprocessarLote = async (idLote: number, idsProcessos: number[]) => {
    setLoadingReprocessar(true);
    try {
      const { data } = await msAw.post(
        `/financeiro/pagamento-taxa/lote/${idLote}/reprocessar`,
        { idsProcessos },
      );
      return data;
    } finally {
      setLoadingReprocessar(false);
    }
  };

  return { loadingReprocessar, reprocessar, reprocessarLote };
}
